import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ContentSlotData } from "graphql/generated";

interface InitialState {
  isFullScreenEventContentOpen: boolean;
  content: ContentSlotData | null;
}

export const initialState: InitialState = {
  isFullScreenEventContentOpen: false,
  content: null,
};

const slice = createSlice({
  name: "eventContent",
  initialState,
  reducers: {
    openFullScreenEventContent: (
      state,
      action: PayloadAction<ContentSlotData>,
    ) => {
      state.isFullScreenEventContentOpen = true;
      state.content = action.payload;
    },
    closeFullScreenEventContent: (state) => {
      state.isFullScreenEventContentOpen = false;
      state.content = null;
    },
  },
});

export const { openFullScreenEventContent, closeFullScreenEventContent } =
  slice.actions;

export default slice.reducer;
